/* RESPONSIBLE TEAM: team-reporting */

import { Chart } from '@highcharts/react';
import Highcharts from 'highcharts/esm/highcharts.src.js';

import '@/features/reporting-charts/highcharts-theme';
import { buildDonutOptions } from '@/features/reporting-charts/transforms/donut';
import type {
  ChartConfig,
  ChartDataResponse,
  RenderContext,
} from '@/features/reporting-charts/types';

interface DonutChartProps {
  data: ChartDataResponse;
  config: ChartConfig;
  renderContext: RenderContext;
  className?: string;
}

export function DonutChart({ data, config, renderContext, className }: DonutChartProps) {
  const options = buildDonutOptions(data, config, renderContext);

  return <Chart highcharts={Highcharts} containerProps={{ className }} options={options} />;
}
